
import { commonInputAttrs } from './shared'
import useTracking from '~/composable/tracking/useTracking';

export default {
  props: {
    label: {
      type: String,
      default: 'Tlf. nummer'
    }
  },
  setup() {
    const { trackFieldRule, trackFieldError } = useTracking()
    return {
      trackFieldError,
      commonInputAttrs,
      phoneRules: [
        v => !!v || trackFieldRule({ message: 'Du skal angive dit telefonnummer', fieldName: 'phone' }),
        v => /^\d{8}$/.test(v) || trackFieldRule({ message: 'Dit telefonnummer skal bestå af 8 cifre', fieldName: 'phone' })
      ]
    }
  }
}
